import { createContext } from 'react'

export const userId = ''

export const UserContext = createContext(userId)
